<div class="log-duration-bar">
    <div
        *ngIf="filter === DurationProperty.clientRtt || filter === DurationProperty.totalTime"
        class="log-duration-bar__used log-duration-bar__used--client-rtt"
        [style.width.%]="percentage[DurationProperty.clientRtt]"
    ></div>
    <div
        *ngIf="filter === DurationProperty.serverRtt || filter === DurationProperty.totalTime"
        class="log-duration-bar__used log-duration-bar__used--server-rtt"
        [style.width.%]="percentage[DurationProperty.serverRtt]"
    ></div>
    <div
        *ngIf="filter === DurationProperty.waf || filter === DurationProperty.totalTime"
        class="log-duration-bar__used log-duration-bar__used--waf-time"
        [style.width.%]="percentage[DurationProperty.waf]"
    ></div>
    <div
        *ngIf="filter === DurationProperty.appResponseTime || filter === DurationProperty.totalTime"
        class="log-duration-bar__used log-duration-bar__used--app-response-time"
        [style.width.%]="percentage[DurationProperty.appResponseTime]"
    ></div>
    <div
        *ngIf="filter === DurationProperty.dataTransferTime || filter === DurationProperty.totalTime"
        class="log-duration-bar__used log-duration-bar__used--data-transfer-time"
        [style.width.%]="percentage[DurationProperty.dataTransferTime]"
    ></div>
</div>
